import {Injectable, OnInit} from '@angular/core';
import {environment} from '../../environments/environment';

declare global {
	interface Window {
		DD_RUM?: any;
	}
}

@Injectable()
export class DataDogRumService {
	initialize() {
		const initDatadogRum = () => {
			if ((window as any).DD_RUM && typeof (window as any).DD_RUM.init === 'function') {
				window.DD_RUM.init({
					clientToken: 'pubd64868c7de617bb6c4b5a92afe77566b',
					applicationId: '6cc8c508-a6ab-4935-953a-2674d50fd615',
					site: 'us3.datadoghq.com',
					service: 'amber-frontend',
					env: environment.production ? 'production' : 'development',
					// Specify a version number to identify the deployed version of your application in Datadog
					// version: '1.0.0',
					sessionSampleRate: 100,
					sessionReplaySampleRate: 100,
					trackInteractions: true,
					trackUserInteractions: true,
					trackResources: true,
					trackLongTasks: true,
					defaultPrivacyLevel: 'mask-user-input',
					allowedTracingUrls: ['https://dev-webapi.pogoenergy.com', /https:\/\/.*\.pogoenergy\.com/, (url) => url.startsWith('https://dev-webapi.pogoenergy.com')],
				});
			} else {
				setTimeout(initDatadogRum, 100); // Check again after 100ms
			}
		}

		initDatadogRum();
	}

	storeUser(user: { id: string; name?: string; email?: string; [key: string]: any }) {
		if (window.DD_RUM) {
			this.addCustomContext('billingAccountNumber', user['billingAccountNumber'])
			if (typeof (window as any).DD_RUM.setUser === 'function') {
				(window as any).DD_RUM.setUser(user);
			}
		}
	}

	addCustomContext(key: string, value: any) {
		if (window.DD_RUM) {
			// window.DD_RUM.addRumGlobalContext(key, value);
		}
	}

	logCustomAction(action: string, attributes: { [key: string]: any }) {
		if (window.DD_RUM) {
			window.DD_RUM.addAction(action, attributes);
		}
	}

	logError(message: string, attributes: { [key: string]: any }) {
		if (window.DD_RUM) {
			window.DD_RUM.addError(message, attributes);
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/datadog/DataDogRumService.ts